import React from 'react';
import { RelationCard, Relation } from './RelationCard';

interface RelationGroupProps {
  title: string;
  relations: Relation[];
  direction: 'incoming' | 'outgoing';
  icon: React.ElementType;
  onEntityClick: (entityId: string) => void;
  onEdit: (relation: Relation) => void;
  onDelete: (relation: Relation) => void;
  isDeleting?: boolean;
}

export const RelationGroup: React.FC<RelationGroupProps> = ({ 
  title, 
  relations, 
  direction,
  icon: Icon,
  onEntityClick,
  onEdit,
  onDelete,
  isDeleting
}) => {
  if (relations.length === 0) return null;

  return (
    <div className="mb-8">
      <div className="flex items-center space-x-2 mb-4">
        <Icon className="h-5 w-5 text-gray-600" />
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
          {relations.length}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {relations.map((relation) => (
          <RelationCard
            key={relation.id}
            relation={relation}
            direction={direction}
            onEntityClick={onEntityClick}
            onEdit={onEdit}
            onDelete={onDelete}
            isDeleting={isDeleting}
          />
        ))}
      </div>
    </div>
  );
};

